import React, { Component } from "react";
import { filter } from "lodash";
import moment from "moment";
import { LinkContainer } from "react-router-bootstrap";
import {
    Navbar,
    Nav,
    NavItem,
    NavDropdown,
    MenuItem,
    Col
} from "react-bootstrap";

import ApiClient from "../../../../utils/ApiClient";
import Session from "../../../../utils/Session";
import UiUtils from "../../../../utils/UiUtils";

import PropTypes from "prop-types";
import NotificationBell from "./components/NotificationBell";
import NotificationDialog from "./components/NotificationDialog";
import WhatsappContact from "./components/WhatsappContact";
import "./Navbar.css";
import { Redirect } from "react-router-dom";

class DashboardNav extends Component {
    constructor() {
        super();
        this.state = {
            notifications: [],
            notificationDialog: {
                notification: null,
            },
            user: {},
        };
    }

    componentDidMount() {
        this.updateNotifications();
        this.setState({ ...this.state, user: Session.getUser() });
    }

    updateNotifications = () => {
        ApiClient.getNotifications()
            .then((res) => {
                if (res.result.code === 200) {
                    if (res.data) {
                        this.setState({
                            notifications: filter(res.data.notificacion, (x) =>
                                moment().isAfter(x.fechaValidacion)
                            ),
                        });
                    }
                }
            })
            .catch((err) => {
                err.toString();
            });
    };

    onLogout = () => {
        Session.clear();
        location.reload();
    };

    onNotificationClicked = (notification) => {
        this.setState({
            notificationDialog: {
                notification: notification,
            },
        });
        if (!notification.leida)
            ApiClient.markNotificationAsRead(notification.id);
    };

    onNotificationDialogClose = () => {
        let notificacions = this.state.notifications;
        notificacions[
            notificacions.findIndex(
                (x) => x === this.state.notificationDialog.notification
            )
        ].leida = true;

        this.setState({
            notificationDialog: {
                notification: null,
            },
            notificacions: notificacions,
        });
    };

    /**
     * INFORME
     */
    onClickAccessBusqueda = () => {
        UiUtils.navigateTo("/dashboard/personas");
    };

    esBusqueda = () => {
        return (
            window.location.href.indexOf("personas") > -1 ||
            window.location.href.indexOf("empresas") > -1 ||
            window.location.href.indexOf("automotores") > -1 ||
            window.location.href.indexOf("Automotores") > -1 ||
            window.location.href.indexOf("telefonos") > -1 ||
            window.location.href.indexOf("Telefonos") > -1 ||
            window.location.href.indexOf("me") > -1 ||
            window.location.href.indexOf("log") > -1 ||
            window.location.href.indexOf("faq") > -1
        );
    };

    /**
     * ENRIQUECIMIENTO
     */

    esEnriquecimiento = () => {
        return window.location.href.indexOf("enriquecimiento-datos") > -1;
    };

    /**
     * SCORE
     */
    onClickAccessScoreBatch = () => {
        UiUtils.navigateTo("/dashboard/score-batch");
    };

    esScoreBatch = () => {
        return window.location.href.indexOf("score-batch") > -1;
    };

    esAsociados = () => {
        return window.location.href.indexOf("asociados") > -1;
    };

    esDashboard = () => {
        return (
            !this.esBusqueda() &&
            !this.esEnriquecimiento() &&
            !this.esScoreBatch() &&
            !this.esAsociados()
        );
    };

    render() {

        return (
            <div>
                
                {this.esBusqueda() && (
                    <div
                        style={
                            this.esBusqueda()
                                ? {
                                      display: "inherit",
                                      marginBottom: "30px",
                                  }
                                : {
                                      display: "none",
                                      marginBottom: "30px",
                                  }
                        }
                    >
                        <Navbar fluid>
                            <Navbar.Header>
                                <Navbar.Brand>
                                    <LinkContainer
                                        to="/dashboard/personas"
                                        className="brand-icon"
                                    >
                                        <img
                                            className="img-responsive"
                                            src={this.props.logo}
                                            alt=""
                                        />
                                    </LinkContainer>
                                </Navbar.Brand>
                                <Navbar.Toggle />
                            </Navbar.Header>
                            <Navbar.Collapse>
                                <Nav
                                    pullLeft
                                    style={{
                                        marginTop: "3px",
                                        minWidth: "76%",
                                        marginLeft: "32px",
                                        borderBottom:
                                            "1px solid rgb(69, 105, 134)",
                                    }}
                                >
                                    <LinkContainer to="/dashboard/personas">
                                        <NavItem href="#">
                                            <span
                                                style={{
                                                    paddingRight: "3px",
                                                }}
                                            >
                                                PERSONAS
                                            </span>
                                            <i
                                                className="fa fa-angle-down"
                                                style={{
                                                    color: "white",
                                                    fontSize: "16px",
                                                }}
                                            ></i>
                                        </NavItem>
                                    </LinkContainer>
                                    <LinkContainer to="/dashboard/empresas">
                                        <NavItem href="#">
                                            <span
                                                style={{
                                                    paddingRight: "3px",
                                                }}
                                            >
                                                EMPRESAS
                                            </span>
                                            <i
                                                className="fa fa-angle-down"
                                                style={{
                                                    color: "white",
                                                    fontSize: "16px",
                                                }}
                                            ></i>
                                        </NavItem>
									</LinkContainer>
									{process.env.REACT_APP_FLAVOR !== "reseller" &&
										<LinkContainer to="/dashboard/automotores">
											<NavItem href="#">
												<span
													style={{
														paddingRight: "3px",
													}}
												>
													AUTOMOTORES
												</span>
												<i
													className="fa fa-angle-down"
													style={{
														color: "white",
														fontSize: "16px",
													}}
												></i>
											</NavItem>
										</LinkContainer>
									}
                                    <LinkContainer to="/dashboard/telefonos">
                                        <NavItem href="#">
                                            <span
                                                style={{
                                                    paddingRight: "3px",
                                                }}
                                            >
                                                TELÉFONOS
                                            </span>
                                            <i
                                                className="fa fa-angle-down"
                                                style={{
                                                    color: "white",
                                                    fontSize: "16px",
                                                }}
                                            ></i>
                                        </NavItem>
                                    </LinkContainer>

                                    <NavItem disabled>
                                        <Col
                                            style={{
                                                width: "90px",
                                            }}
                                            md={12}
                                        ></Col>
                                    </NavItem>

                                    {this.state.user.isAdmin &&
                                    !Session.getUser().isDisa && (
                                        <LinkContainer to="/dashboard/score-batch">
                                            <NavItem href="#">
                                                <i className="fa fa-star-half-o "></i>
                                                <span
                                                    style={{
                                                        paddingLeft: "3px",
                                                    }} >
                                                    SCORE CREDITICIO
                                                </span>
                                            </NavItem>
                                        </LinkContainer>
                                    )}

                                    {process.env.REACT_APP_FLAVOR == "reseller" &&
										(Session.getUser().isDisaAdmin || Session.getUser().isSuperadmin) &&
										process.env.REACT_APP_FLAVOR !== "reseller" &&
                                        <LinkContainer to="/dashboard/asociados">
                                            <NavItem href="#">
                                                <i className="fa fa-star-half-o "></i>
                                                <span
                                                    style={{
                                                        paddingLeft: "3px",
                                                    }}
                                                >
                                                    ASOCIADOS
                                                </span>
                                            </NavItem>
                                        </LinkContainer>
                                    }

                                    <Nav
                                        pullRight
                                        style={{
                                            marginTop: "-10px",
                                            marginRight: "0px",
                                            marginBottom: "25px",
                                        }}
                                    >
                                        <WhatsappContact />

                                        <NavDropdown
                                            style={{
                                                borderRight:
                                                    "1px solid rgb(69, 105, 134)",
                                                borderLeft:
                                                    "1px solid rgb(69, 105, 134)",
                                            }}
                                            title={
                                                <span>
                                                    {" "}
                                                    <i className="fa fa-user-circle-o"></i>
                                                    {this.state.user.userName}{" "}
                                                </span>
                                            }
                                            id="basic-nav-dropdown"
                                        >
                                            <LinkContainer to="/dashboard/me">
                                                <MenuItem>
                                                    <i className="fa fa-user-circle-o" />
                                                    Ver perfil
                                                </MenuItem>
                                            </LinkContainer>
                                            <LinkContainer to="/dashboard/log">
                                                <MenuItem>
                                                    <i className="fa fa-area-chart" />
                                                    Histórico de consultas
                                                </MenuItem>
                                            </LinkContainer>
                                            <MenuItem
                                                onSelect={
                                                    this.props
                                                        .onShowContactDialog
                                                }
                                            >
                                                <i className="fa fa-address-card-o" />
                                                Contacto
                                            </MenuItem>
                                            <MenuItem onSelect={this.onLogout}>
                                                <i className="fa fa-sign-out" />
                                                Cerrar sesión
                                            </MenuItem>
                                        </NavDropdown>
                                        <NavItem>
                                            <NotificationBell
                                                notifications={
                                                    this.state.notifications
                                                }
                                                onNotificationClick={
                                                    this.onNotificationClicked
                                                }
                                            />
                                        </NavItem>
                                    </Nav>
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                        <NotificationDialog
                            notification={
                                this.state.notificationDialog.notification
                            }
                            onClose={this.onNotificationDialogClose}
                        />
                    </div>
                )}

                {this.esEnriquecimiento() && <Redirect to="/"/> }

                {this.esScoreBatch() && (
                    <div
                        style={
                            this.esScoreBatch()
                                ? {
                                      display: "inherit",
                                      marginBottom: "30px",
                                  }
                                : {
                                      display: "none",
                                      marginBottom: "30px",
                                  }
                        }
                    >
                        <Navbar fluid>
                            <Navbar.Header>
                                <Navbar.Brand>
                                    <LinkContainer
                                        to="/dashboard/personas"
                                        className="brand-icon"
                                    >
                                        <img
                                            className="img-responsive"
                                            src={this.props.logo}
                                            alt=""
                                        />
                                    </LinkContainer>
                                </Navbar.Brand>
                                <Navbar.Toggle />
                            </Navbar.Header>

                            <Navbar.Collapse>
                                <Nav
                                    pullLeft
                                    style={{
                                        marginTop: "3px",
                                        minWidth: "76%",
                                        marginLeft: "32px",
                                        borderBottom:
                                            "1px solid rgb(69, 105, 134)",
                                    }}
                                >
                                    <NavItem
                                        disabled
                                        style={{
                                            paddingLeft: "0px",
                                        }}
                                        href="#"
                                    >
                                        <span
                                            style={{
                                                paddingRight: "3px",
                                            }}
                                        >
                                            Score Crediticio
                                        </span>
                                    </NavItem>

                                    <Col md={4}></Col>

                                    <LinkContainer to="/dashboard/personas">
                                        <NavItem href="#">
                                            <i className="fa fa-search"></i>
                                            <span
                                                style={{
                                                    paddingLeft: "3px",
                                                }}
                                            >
                                                INFORME
                                            </span>
                                        </NavItem>
                                    </LinkContainer>

                                    {process.env.REACT_APP_FLAVOR == "reseller" &&
                                    (Session.getUser().isDisaAdmin || Session.getUser().isSuperadmin) &&
                                        <LinkContainer to="/dashboard/asociados">
                                            <NavItem href="#">
                                                <i className="fa fa-star-half-o "></i>
                                                <span
                                                    style={{
                                                        paddingLeft: "3px",
                                                    }}
                                                >
                                                    ASOCIADOS
                                                </span>
                                            </NavItem>
                                        </LinkContainer>
                                    }
                                    
                                    <Nav
                                        pullRight
                                        style={{
                                            marginTop: "-10px",
                                            marginRight: "0px",
                                            marginBottom: "25px",
                                        }}
                                    >
                                        <WhatsappContact />

                                        <NavDropdown
                                            style={{
                                                borderRight:
                                                    "1px solid rgb(69, 105, 134)",
                                                borderLeft:
                                                    "1px solid rgb(69, 105, 134)",
                                            }}
                                            title={
                                                <span>
                                                    {" "}
                                                    <i className="fa fa-user-circle-o"></i>
                                                    {this.state.user.userName}{" "}
                                                </span>
                                            }
                                            id="basic-nav-dropdown"
                                        >
                                            <LinkContainer to="/dashboard/me">
                                                <MenuItem>
                                                    <i className="fa fa-user-circle-o" />
                                                    Ver perfil
                                                </MenuItem>
                                            </LinkContainer>
                                            <LinkContainer to="/dashboard/log">
                                                <MenuItem>
                                                    <i className="fa fa-area-chart" />
                                                    Histórico de consultas
                                                </MenuItem>
                                            </LinkContainer>
                                            <MenuItem
                                                onSelect={
                                                    this.props
                                                        .onShowContactDialog
                                                }
                                            >
                                                <i className="fa fa-address-card-o" />
                                                Contacto
                                            </MenuItem>
                                            <MenuItem onSelect={this.onLogout}>
                                                <i className="fa fa-sign-out" />
                                                Cerrar sesión
                                            </MenuItem>
                                        </NavDropdown>
                                        <NavItem>
                                            <NotificationBell
                                                notifications={
                                                    this.state.notifications
                                                }
                                                onNotificationClick={
                                                    this.onNotificationClicked
                                                }
                                            />
                                        </NavItem>
                                    </Nav>
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                        <NotificationDialog
                            notification={
                                this.state.notificationDialog.notification
                            }
                            onClose={this.onNotificationDialogClose}
                        />
                    </div>
                )}

                {this.esAsociados() && (
                    <div
                        style={
                            this.esAsociados()
                                ? {
                                      display: "inherit",
                                      marginBottom: "30px",
                                  }
                                : {
                                      display: "none",
                                      marginBottom: "30px",
                                  }
                        }
                    >
                        <Navbar fluid>
                            <Navbar.Header>
                                <Navbar.Brand>
                                    <LinkContainer
                                        to="/dashboard/personas"
                                        className="brand-icon"
                                    >
                                        <img
                                            className="img-responsive"
                                            src={this.props.logo}
                                            alt=""
                                        />
                                    </LinkContainer>
                                </Navbar.Brand>
                                <Navbar.Toggle />
                            </Navbar.Header>

                            <Navbar.Collapse>
                                <Nav
                                    pullLeft
                                    style={{
                                        marginTop: "3px",
                                        minWidth: "76%",
                                        marginLeft: "32px",
                                        borderBottom:
                                            "1px solid rgb(69, 105, 134)",
                                    }}
                                >
                                    <NavItem
                                        disabled
                                        style={{
                                            paddingLeft: "0px",
                                        }}
                                        href="#"
                                    >
                                        <span
                                            style={{
                                                paddingRight: "3px",
                                            }}
                                        >
                                            Asociados
                                        </span>
                                    </NavItem>

                                    <Col md={4}></Col>

                                    <LinkContainer to="/dashboard/personas">
                                        <NavItem href="#">
                                            <i className="fa fa-search"></i>
                                            <span
                                                style={{
                                                    paddingLeft: "3px",
                                                }}
                                            >
                                                INFORME
                                            </span>
                                        </NavItem>
                                    </LinkContainer>

                                    {this.state.user.isAdmin &&
                                    !Session.getUser().isDisa && (
                                        <LinkContainer to="/dashboard/score-batch">
                                            <NavItem href="#">
                                                <i className="fa fa-star-half-o "></i>
                                                <span
                                                    style={{
                                                        paddingLeft: "3px",
                                                    }}
                                                >
                                                    SCORE CREDITICIO
                                                </span>
                                            </NavItem>
                                        </LinkContainer>
                                    )}
                                    
                                    <Nav
                                        pullRight
                                        style={{
                                            marginTop: "-10px",
                                            marginRight: "0px",
                                            marginBottom: "25px",
                                        }}
                                    >
                                        <WhatsappContact />

                                        <NavDropdown
                                            style={{
                                                borderRight:
                                                    "1px solid rgb(69, 105, 134)",
                                                borderLeft:
                                                    "1px solid rgb(69, 105, 134)",
                                            }}
                                            title={
                                                <span>
                                                    {" "}
                                                    <i className="fa fa-user-circle-o"></i>
                                                    {this.state.user.userName}{" "}
                                                </span>
                                            }
                                            id="basic-nav-dropdown"
                                        >
                                            <LinkContainer to="/dashboard/me">
                                                <MenuItem>
                                                    <i className="fa fa-user-circle-o" />
                                                    Ver perfil
                                                </MenuItem>
                                            </LinkContainer>
                                            <LinkContainer to="/dashboard/log">
                                                <MenuItem>
                                                    <i className="fa fa-area-chart" />
                                                    Histórico de consultas
                                                </MenuItem>
                                            </LinkContainer>
                                            <MenuItem
                                                onSelect={
                                                    this.props
                                                        .onShowContactDialog
                                                }
                                            >
                                                <i className="fa fa-address-card-o" />
                                                Contacto
                                            </MenuItem>
                                            <MenuItem onSelect={this.onLogout}>
                                                <i className="fa fa-sign-out" />
                                                Cerrar sesión
                                            </MenuItem>
                                        </NavDropdown>
                                        <NavItem>
                                            <NotificationBell
                                                notifications={
                                                    this.state.notifications
                                                }
                                                onNotificationClick={
                                                    this.onNotificationClicked
                                                }
                                            />
                                        </NavItem>
                                    </Nav>
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                        <NotificationDialog
                            notification={
                                this.state.notificationDialog.notification
                            }
                            onClose={this.onNotificationDialogClose}
                        />
                    </div>
                )}
            </div>
        );
    }
}

DashboardNav.propTypes = {
    onShowContactDialog: PropTypes.func.isRequired,
    logo: PropTypes.string.isRequired,
    match: PropTypes.object,
};

export default DashboardNav;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/navbar/Navbar.js